
<main-form-modal (toggleChange)="setVal($event)">
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">

            <donationCategory-edit *ngSwitchCase="true"></donationCategory-edit>
            <donationCategory-details *ngSwitchCase="false"></donationCategory-details>
        </div>
    </ng-template>
</main-form-modal>
